export enum RebateSchemaType {
  Base = 0, //not a real type in backend api, just easy to use in the frontend
  Rate = 1,
  Pips = 2,
  Commission = 3,
  Rebate = 4, //not a real type in backend api, just easy to use in the frontend
}
